export default __webpack_public_path__ + "static/media/1Enviro Pump Services.cb45b80a.png";